/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTeamMemberAvailabilityRequest} from '@cash-web/protos/squareup/timecards/scheduling/availability.pb'
import {UpdateTeamMemberAvailabilityResponse} from '@cash-web/protos/squareup/timecards/scheduling/availability.pb'


export const updateTeamMemberAvailability = (request: UpdateTeamMemberAvailabilityRequest, options?: CashRequestOptions) => post<UpdateTeamMemberAvailabilityRequest, UpdateTeamMemberAvailabilityResponse>("/2.0/cash/update-team-member-availability", request, {...options, rejectOnError: true })